import { default as MuiDialog } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    dialogTitleContainer: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(3),
    },
    dialogTitle: {
      padding: 0,
    },
    dialogCloseButton: {
      marginLeft: "auto",
    },
  });

interface DialogProps extends WithStyles<typeof styles> {
  id?: string;
  className?: string;
  fullScreen?: boolean;
  title?: string;
  actions?: any;
  open: boolean;
  children: React.ReactNode;
  onCloseClick: (event: React.MouseEvent<HTMLElement>) => void;
  onEscapeKeyDown: (event: React.SyntheticEvent<{}>) => void;
}

export const DialogComponent = (props: DialogProps) => {
  const { id, className, fullScreen, open, title, actions, onCloseClick, onEscapeKeyDown, classes, children } = props;

  return (
    <MuiDialog
      id={id}
      classes={{ paper: className }}
      fullScreen={fullScreen}
      open={open}
      aria-labelledby={id && `${id}_title`}
      onEscapeKeyDown={onEscapeKeyDown}
    >
      <div className={classes.dialogTitleContainer}>
        <DialogTitle id={id && `${id}_title`} classes={{ root: classes.dialogTitle }}>
          {title}
        </DialogTitle>
        <IconButton className={classes.dialogCloseButton} title={"Close"} onClick={onCloseClick}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent id={id && `${id}_content`}>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export const Dialog = withStyles(styles)(withMobileDialog<DialogProps>()(DialogComponent));
